export class Estimation {
    static jsonMap = {
        espece: { key: 'espece', optional: true, default: '' },
        groupeVarietal: { key: 'groupeVarietal', optional: true, default: '' },
        taux: { key: 'taux', optional: true }
    };

    public espece: string;
    public groupeVarietal: string;
    public taux: number;
}
